import { AsyncStorage } from '@pletly/common';
import { Settings } from './type';

const SETTINGS_LOCAL_STORAGE_KEY = 'user-client-settings';

async function getSettings() {
	const settingsString = await AsyncStorage.getString(SETTINGS_LOCAL_STORAGE_KEY);

	if (!settingsString) {
		return;
	}

	return JSON.parse(settingsString) as Settings;
}

async function setSettings(settings: Settings) {
	const settingsString = JSON.stringify(settings);

	return AsyncStorage.setStorageItem(SETTINGS_LOCAL_STORAGE_KEY, settingsString);
}

export { getSettings, setSettings };
